export { default } from './SkeletonCalendarMobile';
